import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { generalSubHeaderStyles } from "../example-questions/ExampleQuestions";
const useStyles = makeStyles(theme => ({
  ...generalSubHeaderStyles(theme),
  richTextContent: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    wordBreak: "break-word"
  },
  [theme.breakpoints.up("sm")]: {
    richTextContent: {
      textAlign: "left",
      alignItems: "flex-start"
    }
  }
}));
const RichText = ({
  content,
  leftSpaceContainer,
  extraRichTextStyle = "",
  subHeaderContainer
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    className: leftSpaceContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    className: `${extraRichTextStyle} ${classes.richTextContent} ${subHeaderContainer ? subHeaderContainer : classes.generalSubHeaderContent}`,
    color: "textPrimary",
    dangerouslySetInnerHTML: {
      __html: content.text
    },
    component: "div",
    variant: "body2"
  }));
};
RichText.propTypes = {
  content: PropTypes.object.isRequired,
  leftSpaceContainer: PropTypes.string,
  subHeaderStyle: PropTypes.string,
  extraRichTextStyle: PropTypes.string,
  subHeaderContainer: PropTypes.string
};
export default RichText;